<template>
  <div>
    <nuxt-link
      v-if="internalLink"
      :to="getLinkFromOption()"
      @click.native="hideModalGaEvent(getLinkFromOption())"
      >{{ $t(value) }}
    </nuxt-link>
    <a
      v-else
      :href="getLinkFromOption()"
      target="_blank"
      rel="noopener noreferrer"
      @click="hideModalGaEvent(getLinkFromOption())"
      >{{ $t(value) }}</a
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    modalName: {
      type: String,
      required: true
    },
    internalLink: {
      type: Boolean,
      required: false,
      default: false
    },
    translateLink: {
      type: Boolean,
      required: false,
      default: false
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    linkSubscriptor: {
      type: String,
      required: false,
      default: ''
    },
    linkUrlBuilder: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('discover', ['getDiscoverLink'])
  },
  methods: {
    getLinkFromOption() {
      const { link, linkSubscriptor, linkUrlBuilder, translateLink } = this;
      const linkParams = {
        link,
        linkSubscriptor,
        linkUrlBuilder,
        translateLink,
        localePath: this.localePath,
        urlBuilder: this.$urlBuilder,
        trailingSlash: this.$trailingSlash,
        isSubscriptor: this.$auth.user?.isSubscriptor
      };
      return this.getDiscoverLink(linkParams);
    },
    hideModalGaEvent(url) {
      this.$bvModal.hide(this.modalName);
      this.$ga.event('Discover', 'Click Discover Block', url);
    }
  }
};
</script>
